"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_COUPON_FROM_CART = exports.APPLY_COUPON_TO_CART = exports.ADD_CUSTOM_WARRANTY_TO_CART = exports.ADD_WARRANTY_TO_CART = exports.REMOVE_ITEM_FROM_CART = exports.UPDATE_CART_ITEMS = exports.ADD_PRODUCTS_TO_CART = exports.GET_CART = exports.CREATE_CART = void 0;
/* eslint-disable */
const typedefs_1 = require("./typedefs");
exports.CREATE_CART = `
    mutation {
        createEmptyCartV2 {
            cartId
        }
    }
`;
exports.GET_CART = `
    query ($cartId: String!) {
        getCartV2(cartId: $cartId) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.ADD_PRODUCTS_TO_CART = `
    mutation ($cartId: String!, $cartItems: [cartItemInputV2!]!) {
        addProductsToCartV2(cartId: $cartId, cartItems: $cartItems) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.UPDATE_CART_ITEMS = `
    mutation ($cartId: String!, $itemsToUpdate: ProductUpdateInput!) {
        updateCartItemsV2(cartId: $cartId, itemsToUpdate: $itemsToUpdate) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.REMOVE_ITEM_FROM_CART = `
    mutation ($cartId: String!, $itemId: Int!) {
        removeItemFromCartV2(cartId: $cartId, itemId: $itemId) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.ADD_WARRANTY_TO_CART = `
    mutation ($cartId: String!, $qty:Int!, $warranty: WarrantyCartItemInput!) {
        addWarrantyToCartV2(cartId:$cartId, qty:$qty, warranty:$warranty) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.ADD_CUSTOM_WARRANTY_TO_CART = `
    mutation ($cartId: String!, $qty:Int!, $warranty: WarrantyCartItemInput!, $leadToken:String) {
        addCustomWarrantyToCartV2(cartId:$cartId, qty:$qty, warranty:$warranty, leadToken:$leadToken) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.APPLY_COUPON_TO_CART = `
    mutation ($cartId: String!, $couponCode: String!) {
        applyCouponToCartV2(cartId: $cartId, couponCode: $couponCode) {
            ${typedefs_1.cartObject}
        }
    }
`;
exports.REMOVE_COUPON_FROM_CART = `
    mutation ($cartId: String!) {
        removeCouponFromCartV2(cartId: $cartId) {
            ${typedefs_1.cartObject}
        }
    }
`;
//# sourceMappingURL=queries.js.map